import {
  BtnLanguage,
  LanguageBox,
  LanguageListBox,
  PolicyArticleTitle,
  PolicyContainer,
  PolicyHyphenList,
  PolicyNumberList,
  PolicySectionTitle,
  PolicyText,
  PolicyTitle,
  PolicyVersion,
  StyledIconDropdown,
  StyledIconGlobal,
} from "styles/PolicyCommon";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const ServiceTh = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onLanguageClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    document.documentElement.lang = "th";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <LanguageBox isOpen={isOpen}>
        <BtnLanguage onClick={onLanguageClick}>
          <StyledIconGlobal />
          TH
          <StyledIconDropdown />
        </BtnLanguage>
        <LanguageListBox>
          <ul>
            <li>
              <Link to="/policy/en/service">EN</Link>
            </li>
            <li>
              <Link to="/policy/ja/service">JA</Link>
            </li>
            <li>
              <Link to="/policy/vi/service">VI</Link>
            </li>
            <li className="selected">
              <em>TH</em>
            </li>
            <li>
              <Link to="/policy/id/service">ID</Link>
            </li>
            <li>
              <Link to="/policy/es/service">ES</Link>
            </li>
          </ul>
        </LanguageListBox>
      </LanguageBox>

      <PolicyTitle>ข้อกำหนดการใช้บริการ pregnancy&amp;baby</PolicyTitle>

      <PolicyVersion>
        <strong>วันที่มีผลบังคับใช้: [21 กันยายน 2026]</strong>
        <br />
        <strong>ปรับปรุงล่าสุด: [25 สิงหาคม 2026]</strong>
      </PolicyVersion>

      <PolicySectionTitle>
        บทที่ 1 ยินดีต้อนรับสู่ pregnancy&amp;baby
      </PolicySectionTitle>
      <PolicyText>
        <strong>pregnancy&amp;baby</strong>{" "}
        ให้บริการหลากหลายเพื่อสนับสนุนผู้ใช้ตลอดช่วงการเตรียมตัวตั้งครรภ์
        การรักษาภาวะมีบุตรยาก การตั้งครรภ์ การคลอดบุตร การฟื้นฟูหลังคลอด
        และการดูแลเด็ก บริการดังกล่าวอาจรวมถึงการบันทึกข้อมูลสุขภาพและไดอารี่
        รายงานเฉพาะบุคคล เนื้อหาให้ข้อมูล ฟีเจอร์ชุมชน
        และฟีเจอร์ที่เกี่ยวข้องอื่น ๆ
      </PolicyText>
      <PolicyText>
        ข้อกำหนดการใช้บริการฉบับนี้ (“ข้อกำหนด”)
        ใช้บังคับกับการใช้แอปพลิเคชันมือถือ <strong>pregnancy&amp;baby</strong>{" "}
        เว็บไซต์ และบริการที่เกี่ยวข้องทั้งหมด (รวมเรียกว่า “บริการ”)
        ซึ่งให้บริการโดย Connecti Co., Ltd. (“บริษัท”, “เรา” หรือ “ของเรา”)
      </PolicyText>
      <PolicyText>โปรดอ่านข้อกำหนดฉบับนี้อย่างละเอียดก่อนใช้บริการ</PolicyText>

      <PolicyArticleTitle>ข้อ 1 วัตถุประสงค์และคำนิยาม</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          ข้อกำหนดฉบับนี้กำหนดสิทธิ หน้าที่ ความรับผิดชอบ เงื่อนไขการใช้บริการ
          และเรื่องอื่น ๆ
          ที่เกี่ยวข้องกับการใช้บริการระหว่างบริษัทกับผู้ใช้ที่ยอมรับข้อกำหนดฉบับนี้และลงทะเบียนบัญชีเรียบร้อยแล้ว
          (“สมาชิก”)
        </li>
        <li>
          สำหรับข้อกำหนดฉบับนี้ คำต่อไปนี้มีความหมายดังนี้
          <PolicyHyphenList>
            <li>
              <strong>“บริการ”</strong> หมายถึง แอปพลิเคชันมือถือ
              pregnancy&amp;baby เว็บไซต์
              และบริการที่เกี่ยวข้องซึ่งบริษัทให้บริการ
            </li>
            <li>
              <strong>“สมาชิก”</strong> หมายถึง
              ผู้ใช้ที่ยอมรับข้อกำหนดฉบับนี้และลงทะเบียนใช้บริการเรียบร้อยแล้ว
            </li>
            <li>
              <strong>“บัญชี”</strong> หมายถึง
              บัญชีที่สมาชิกใช้เพื่อเข้าถึงและใช้บริการ
            </li>
            <li>
              <strong>“ข้อมูลบัญชี”</strong> หมายถึง
              ข้อมูลที่เกี่ยวข้องกับบัญชีของสมาชิกซึ่งสามารถดูหรือจัดการผ่านบริการได้
            </li>
            <li>
              <strong>“เนื้อหา”</strong> หมายถึง ข้อความ รูปภาพ ภาพถ่าย วิดีโอ
              ข้อมูล ข้อคิดเห็น โพสต์ และสื่ออื่น ๆ ที่ให้บริการผ่านหรือถูกส่ง
              อัปโหลด หรือโพสต์ลงในบริการ
            </li>
            <li>
              <strong>“บริการแบบมีค่าใช้จ่าย”</strong> หมายถึง เนื้อหาดิจิทัล
              ฟีเจอร์ รายงาน
              หรือบริการอื่นที่บริษัทให้บริการและสามารถใช้ได้โดยการ
              <strong>ชำระเงินครั้งเดียว</strong>
            </li>
          </PolicyHyphenList>
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        ข้อ 2 การมีผลบังคับใช้และการแก้ไขข้อกำหนด
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          ข้อกำหนดฉบับนี้มีผลบังคับใช้เมื่อบริษัทแสดงข้อกำหนดผ่านบริการหรือวิธีการที่เหมาะสมอื่น
          และสมาชิกได้ให้ความยินยอมต่อข้อกำหนดดังกล่าว
        </li>
        <li>
          บริษัทอาจแก้ไขข้อกำหนดฉบับนี้ภายในขอบเขตที่กฎหมายที่ใช้บังคับอนุญาต
        </li>
        <li>
          เมื่อมีการแก้ไขข้อกำหนด
          บริษัทจะแจ้งรายละเอียดการแก้ไขและวันที่มีผลบังคับใช้ให้สมาชิกทราบโดยทั่วไปอย่างน้อย{" "}
          <strong>15 วันก่อนวันที่ข้อกำหนดฉบับแก้ไขมีผลบังคับใช้</strong>
        </li>
        <li>
          หากการแก้ไขอาจก่อให้เกิดผลเสียที่สำคัญต่อสมาชิก
          โดยทั่วไปบริษัทจะแจ้งให้ทราบอย่างน้อย{" "}
          <strong>30 วันก่อนวันที่มีผลบังคับใช้</strong> ผ่านอีเมล
          การแจ้งเตือนภายในแอป การแจ้งเตือนแบบพุช
          หรือวิธีการทางอิเล็กทรอนิกส์ที่เหมาะสมอื่น
        </li>
        <li>
          ในกรณีที่กฎหมายที่ใช้บังคับอนุญาต
          หากบริษัทแจ้งอย่างชัดเจนว่าการไม่คัดค้านภายในระยะเวลาที่กำหนดจะถือว่าเป็นการยอมรับข้อกำหนดฉบับแก้ไข
          และสมาชิกไม่คัดค้านภายในระยะเวลาดังกล่าว
          สมาชิกอาจถือว่าได้ยอมรับข้อกำหนดฉบับแก้ไขแล้ว
        </li>
        <li>
          หากสมาชิกไม่ยอมรับข้อกำหนดฉบับแก้ไข
          สมาชิกสามารถยุติสัญญาการใช้บริการได้โดยการลบบัญชี
        </li>
        <li>
          โดยทั่วไปข้อกำหนดฉบับนี้จะมีผลตั้งแต่วันที่สมาชิกยอมรับข้อกำหนดจนถึงวันที่สัญญาการใช้บริการสิ้นสุดลง
          ทั้งนี้
          ข้อกำหนดบางส่วนที่โดยสภาพควรมีผลต่อเนื่องหลังการยุติสัญญาอาจยังคงมีผลต่อไป
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>ข้อ 3 กฎเพิ่มเติม</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          เรื่องที่ไม่ได้กำหนดไว้อย่างชัดเจนในข้อกำหนดฉบับนี้
          ให้เป็นไปตามกฎหมายที่ใช้บังคับ เงื่อนไขของบริการเฉพาะ
          และนโยบายการดำเนินงาน แนวทาง และกฎที่บริษัทกำหนด
          (“นโยบายการดำเนินงาน”)
        </li>
        <li>
          หากบริการใดมีข้อกำหนดเพิ่มเติมเฉพาะ
          ข้อกำหนดเพิ่มเติมดังกล่าวจะใช้กับบริการนั้น
        </li>
        <li>
          หากข้อกำหนดฉบับนี้ขัดกับบทบัญญัติบังคับของกฎหมายที่ใช้บังคับ
          ให้กฎหมายดังกล่าวมีผลเหนือกว่า
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>
        บทที่ 2 การสมัครสมาชิกและการจัดการบัญชี
      </PolicySectionTitle>
      <PolicyArticleTitle>ข้อ 4 การสมัครสมาชิก</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          ผู้ใช้จะถือว่าได้ยอมรับข้อกำหนดฉบับนี้เมื่อเลือกปุ่มหรือช่องทำเครื่องหมาย
          “ยอมรับ”, “Accept”, “Continue”
          หรือข้อความอื่นที่มีความหมายเทียบเท่าซึ่งแสดงในระหว่างขั้นตอนการสมัครสมาชิก
        </li>
        <li>
          เพื่อสมัครใช้บริการ
          ผู้ใช้ต้องให้ข้อมูลที่จำเป็นและดำเนินขั้นตอนการสมัครตามที่บริษัทกำหนดให้เสร็จสมบูรณ์
        </li>
        <li>
          สมาชิกสามารถสร้างหรือเข้าถึงบัญชีผ่านวิธีการที่บริษัทรองรับ ซึ่งรวมถึง
          <PolicyHyphenList>
            <li>อีเมล</li>
            <li>Google</li>
            <li>Apple</li>
          </PolicyHyphenList>
        </li>
        <li>
          บริษัทอาจขอข้อมูลเพิ่มเติมหรือการยืนยันตัวตนเพิ่มเติม
          เมื่อมีความจำเป็นอย่างสมเหตุสมผลเพื่อให้บริการฟีเจอร์เฉพาะ
          ปกป้องสมาชิก ปฏิบัติตามกฎหมายที่ใช้บังคับ
          หรือป้องกันการใช้บริการโดยมิชอบ
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        ข้อ 5 การอนุมัติ การระงับ และการปฏิเสธการสมัคร
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          การสมัครสมาชิกจะเสร็จสมบูรณ์เมื่อผู้ใช้ส่งคำขอสมัครและบริษัทอนุมัติคำขอดังกล่าว
        </li>
        <li>
          โดยทั่วไปบริษัทจะอนุมัติคำขอสมัครที่ดำเนินการอย่างถูกต้องครบถ้วน
          อย่างไรก็ตาม บริษัทอาจระงับ ปฏิเสธ หรือยกเลิกการสมัครในกรณีต่อไปนี้
          <PolicyHyphenList>
            <li>
              ผู้สมัครใช้ชื่อ ที่อยู่อีเมล บัญชี
              หรือข้อมูลอื่นของบุคคลอื่นโดยไม่ได้รับอนุญาต
            </li>
            <li>ผู้สมัครให้ข้อมูลอันเป็นเท็จ ไม่ครบถ้วน หรือทำให้เข้าใจผิด</li>
            <li>บริษัทไม่มีศักยภาพทางเทคนิคเพียงพอในการให้บริการ</li>
            <li>
              มีปัญหาทางเทคนิคหรือการดำเนินงานที่ทำให้ไม่สามารถให้บริการได้
            </li>
            <li>
              ผู้ที่เคยถูกระงับหรือจำกัดการใช้บริการพยายามหลีกเลี่ยงมาตรการดังกล่าวโดยการสร้างบัญชีใหม่
            </li>
            <li>
              การสมัครดังกล่าวขัดต่อกฎหมายที่ใช้บังคับ ข้อกำหนดฉบับนี้
              หรือนโยบายการดำเนินงาน หรือ
            </li>
            <li>
              บริษัทมีเหตุผลอันสมควรที่จะเห็นว่าไม่สามารถอนุมัติการสมัครได้ด้วยเหตุทางเทคนิค
              ความปลอดภัย การดำเนินงาน หรือกฎหมายที่ชอบด้วยเหตุผล
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          หากภายหลังบริษัทพบว่าสมาชิกสมัครโดยฝ่าฝืนข้อกำหนดในข้อนี้
          บริษัทอาจจำกัดการใช้บริการ ระงับบัญชี หรือลบบัญชีตามความเหมาะสม
        </li>
      </PolicyNumberList>
      <PolicyArticleTitle>ข้อ 6 การจัดการบัญชี</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          สมาชิกมีหน้าที่รับผิดชอบในการจัดการบัญชีของตนอย่างเหมาะสม
          และป้องกันไม่ให้บุคคลที่สามใช้งานโดยไม่ได้รับอนุญาต
        </li>
        <li>
          หากสมาชิกทราบว่าบัญชีของตนถูกเข้าถึงหรือใช้งานโดยไม่ได้รับอนุญาต
          สมาชิกควรดำเนินมาตรการที่เหมาะสมเพื่อรักษาความปลอดภัยของบัญชีโดยเร็ว
          และแจ้งบริษัท
        </li>
        <li>
          สมาชิกสามารถดูหรือแก้ไขข้อมูลบัญชีบางส่วนผ่านบริการได้ ทั้งนี้
          ข้อมูลบางประเภทอาจไม่สามารถแก้ไขโดยตรงได้หากมีข้อจำกัดที่จำเป็นด้านความปลอดภัยของบัญชี
          การระบุตัวตน หรือเหตุผลทางเทคนิค
        </li>
        <li>
          หากสมาชิกจำเป็นต้องแก้ไขข้อมูลที่ไม่สามารถเปลี่ยนแปลงได้โดยตรง
          สมาชิกสามารถติดต่อฝ่ายบริการลูกค้า
        </li>
        <li>
          เมื่อสมาชิกใช้การเข้าสู่ระบบผ่าน Google, Apple
          การยืนยันตัวตนจะดำเนินการโดยใช้โทเค็นหรือกลไกยืนยันตัวตนอื่นที่ผู้ให้บริการภายนอกนั้นจัดให้
          บริษัทไม่ได้ให้บริการกู้คืนรหัสผ่านสำหรับข้อมูลการเข้าสู่ระบบที่ผู้ให้บริการภายนอกเป็นผู้จัดการ
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>บทที่ 3 การใช้บริการ</PolicySectionTitle>
      <PolicyArticleTitle>ข้อ 7 การให้บริการ</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          สมาชิกสามารถใช้บริการได้หลังจากสมัครสมาชิกและดำเนินขั้นตอนที่จำเป็นสำหรับฟีเจอร์ที่เกี่ยวข้องเรียบร้อยแล้ว
        </li>
        <li>
          บริการอาจรวมถึงฟีเจอร์ต่าง ๆ เช่น
          <PolicyHyphenList>
            <li>การเตรียมตัวตั้งครรภ์และการติดตามรอบประจำเดือน</li>
            <li>การบันทึกและวิเคราะห์ผลตรวจการตกไข่และผลตรวจการตั้งครรภ์</li>
            <li>การบันทึกการรักษาภาวะมีบุตรยาก</li>
            <li>ไดอารี่การตั้งครรภ์และรายงานที่เกี่ยวข้องกับการตั้งครรภ์</li>
            <li>รายงานการเจริญเติบโตของทารกในครรภ์</li>
            <li>การจัดการน้ำหนักระหว่างตั้งครรภ์และหลังคลอด</li>
            <li>ฟีเจอร์เกี่ยวกับการเจริญเติบโตและพัฒนาการของเด็ก</li>
            <li>การบันทึกข้อมูลสุขภาพและการดูแลเด็ก</li>
            <li>คู่มือและเนื้อหาให้ข้อมูล</li>
            <li>ฟีเจอร์ชุมชน</li>
            <li>ฟีเจอร์อื่น ๆ ที่บริษัทจัดให้</li>
          </PolicyHyphenList>
        </li>
        <li>
          การใช้ฟีเจอร์บางอย่างอาจต้องมี
          <PolicyHyphenList>
            <li>ข้อมูลเพิ่มเติม;</li>
            <li>
              ความยินยอมแยกต่างหาก
              รวมถึงความยินยอมในการประมวลผลข้อมูลสุขภาพหรือข้อมูลส่วนบุคคลที่มีความอ่อนไหวอื่น;
            </li>
            <li>ข้อกำหนดด้านอายุหรือคุณสมบัติ;</li>
            <li>ข้อกำหนดหรือนโยบายเพิ่มเติม หรือ</li>
            <li>
              เงื่อนไขอื่นที่มีความจำเป็นอย่างสมเหตุสมผลในการให้บริการฟีเจอร์นั้น
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          บริษัทอาจให้บริการอัปเดตซอฟต์แวร์เพื่อปรับปรุงหรือเปลี่ยนแปลงบริการ
          หรือเพื่อเพิ่มหรือลบฟีเจอร์
          สมาชิกควรใช้แอปพลิเคชันเวอร์ชันล่าสุดเมื่อสามารถทำได้
        </li>
        <li>
          บริษัทอาจแสดงประกาศเกี่ยวกับบริการ ข้อความด้านการจัดการ
          เนื้อหาให้ข้อมูล หรือการสื่อสารอื่นภายในบริการ
        </li>
        <li>
          อีเมล การแจ้งเตือนแบบพุช หรือการสื่อสารในลักษณะเดียวกันเพื่อการค้า
          หรือการส่งเสริมการขาย
          จะถูกส่งตามความยินยอมของสมาชิกและกฎหมายที่ใช้บังคับ
        </li>
        <li>
          หากสมาชิกพบข้อผิดพลาดของระบบหรือปัญหาอื่นระหว่างใช้บริการ
          สามารถติดต่อฝ่ายบริการลูกค้าได้ที่:
          <br />
          <a href="mailto:after10month@connect-i.co.kr">
            after10month@connect-i.co.kr
          </a>
        </li>
        <li>
          สมาชิกเป็นผู้รับผิดชอบค่าบริการข้อมูลหรือค่าบริการโทรคมนาคมใด ๆ
          ที่ผู้ให้บริการอินเทอร์เน็ตหรือผู้ให้บริการเครือข่ายมือถือเรียกเก็บจากการใช้บริการ
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        ข้อ 8 การระงับ การเปลี่ยนแปลง และการยุติบริการ
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          บริษัทจะใช้ความพยายามอย่างสมเหตุสมผลในการให้บริการอย่างต่อเนื่องและมีเสถียรภาพ
        </li>
        <li>
          เว้นแต่กฎหมายจะกำหนดไว้เป็นอย่างอื่น
          บริการทั้งหมดหรือบางส่วนอาจถูกจำกัด ระงับ เปลี่ยนแปลง
          หรือยุติชั่วคราวในกรณีต่อไปนี้
          <PolicyHyphenList>
            <li>การบำรุงรักษา ตรวจสอบ ซ่อมแซม หรือเปลี่ยนระบบหรืออุปกรณ์;</li>
            <li>
              ไฟฟ้าดับ อุปกรณ์ขัดข้อง เครือข่ายหนาแน่น หรือปัญหาทางเทคนิคอื่น;
            </li>
            <li>การสิ้นสุดหรือเปลี่ยนแปลงข้อตกลงกับผู้ให้บริการภายนอก;</li>
            <li>คำสั่งของหน่วยงานรัฐ กฎระเบียบ หรือข้อกำหนดทางกฎหมาย;</li>
            <li>
              การเปลี่ยนแปลงนโยบายด้านการดำเนินงาน ความปลอดภัย หรือบริการ;
            </li>
            <li>
              ภัยธรรมชาติ สถานการณ์ฉุกเฉิน สงคราม ความไม่สงบทางสังคม
              หรือเหตุสุดวิสัยอื่น หรือ
            </li>
            <li>
              เหตุการณ์อื่นที่ทำให้ไม่สามารถให้บริการต่อไปได้โดยสมเหตุสมผล
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          หากสามารถดำเนินการได้อย่างสมเหตุสมผล
          บริษัทจะแจ้งให้ทราบล่วงหน้าเกี่ยวกับการระงับหรือยุติบริการที่มีผลกระทบอย่างมีนัยสำคัญ
          ตามวิธีการที่กำหนดไว้ในข้อ 21
        </li>
        <li>
          บริษัทอาจไม่สามารถแจ้งล่วงหน้าได้หากการระงับเกิดจากเหตุการณ์ที่ไม่คาดคิดหรืออยู่นอกการควบคุม
          เช่น เซิร์ฟเวอร์ล้มเหลว ระบบขัดข้อง เหตุการณ์ด้านความปลอดภัย
          หรือความล้มเหลวของระบบภายนอก
        </li>
        <li>
          ในกรณีดังกล่าว
          บริษัทจะใช้ความพยายามอย่างสมเหตุสมผลเพื่อกู้คืนบริการโดยเร็วที่สุด
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>ข้อ 9 การจัดการเนื้อหาของสมาชิก</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          หากเนื้อหาที่สมาชิกโพสต์ละเมิดลิขสิทธิ์ ความเป็นส่วนตัว
          ทรัพย์สินทางปัญญา หรือสิทธิอื่น
          เจ้าของสิทธิอาจร้องขอให้บริษัทดำเนินการตามสมควรตามกฎหมายที่ใช้บังคับ
        </li>
        <li>
          บริษัทอาจจำกัดการเข้าถึง ลบชั่วคราว หรือลบเนื้อหาอย่างถาวร
          หากมีเหตุอันสมควรที่จะเห็นว่าเนื้อหานั้น
          <PolicyHyphenList>
            <li>ขัดต่อกฎหมายที่ใช้บังคับ;</li>
            <li>ละเมิดสิทธิของบุคคลอื่น;</li>
            <li>ฝ่าฝืนข้อกำหนดฉบับนี้หรือนโยบายการดำเนินงาน;</li>
            <li>เป็นภัยต่อความปลอดภัยหรือการดำเนินงานปกติของบริการ หรือ</li>
            <li>จำเป็นต้องดำเนินการเพื่อคุ้มครองสมาชิกหรือบุคคลที่สาม</li>
          </PolicyHyphenList>
        </li>
        <li>
          ขั้นตอนเกี่ยวกับการรายงาน การนำเนื้อหาออก
          และการดำเนินการเกี่ยวกับเนื้อหาอื่น ๆ
          อาจกำหนดรายละเอียดเพิ่มเติมไว้ในนโยบายการดำเนินงาน
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        ข้อ 10 สิทธิในเนื้อหาและการใช้เนื้อหา
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          สมาชิกสามารถอัปโหลดหรือโพสต์รูปภาพ ข้อความ ข้อมูล วิดีโอ ความคิดเห็น
          ข้อเสนอแนะ และเนื้อหาอื่นเข้าสู่บริการ
        </li>
        <li>
          สมาชิกยังคงเป็นเจ้าของสิทธิในทรัพย์สินทางปัญญาที่ตนมีอยู่ในเนื้อหาที่ตนโพสต์
        </li>
        <li>
          เมื่อสมาชิกโพสต์เนื้อหาในพื้นที่ของบริการที่มีไว้เพื่อแบ่งปันกับบุคคลอื่น
          สมาชิกให้สิทธิแก่บริษัทแบบไม่ผูกขาดในการโฮสต์ จัดเก็บ ทำซ้ำ แสดงผล
          ปรับรูปแบบ
          และแก้ไขทางเทคนิคในขอบเขตที่จำเป็นอย่างสมเหตุสมผลเพื่อดำเนินงาน แสดง
          ให้บริการ และปรับปรุงฟีเจอร์ที่เกี่ยวข้อง
        </li>
        <li>
          เนื้อหาของสมาชิกอาจปรากฏในผลการค้นหา ฟีด พื้นที่เนื้อหาเฉพาะบุคคล
          หรือส่วนอื่นภายในบริการตามความเหมาะสมของฟีเจอร์ที่เนื้อหานั้นถูกโพสต์
        </li>
        <li>
          บริษัทอาจปฏิเสธ จำกัด หรือลบเนื้อหาโดยไม่ต้องแจ้งล่วงหน้า
          หากมีเหตุอันสมควรที่จะเห็นว่าเนื้อหานั้น
          <PolicyHyphenList>
            <li>ผิดกฎหมาย;</li>
            <li>ลามกหรือเกี่ยวข้องกับการแสวงหาประโยชน์ทางเพศ;</li>
            <li>
              ส่งเสริมความเกลียดชัง การเลือกปฏิบัติที่ผิดกฎหมาย หรือความรุนแรง;
            </li>
            <li>เป็นสแปมหรือโฆษณาที่ไม่ได้รับอนุญาต;</li>
            <li>ปลอมแปลงเป็นบุคคลอื่น;</li>
            <li>ละเมิดสิทธิของบุคคลที่สาม;</li>
            <li>มีลักษณะหลอกลวงหรือทำให้เข้าใจผิด หรือ</li>
            <li>ฝ่าฝืนข้อกำหนดฉบับนี้หรือนโยบายการดำเนินงาน</li>
          </PolicyHyphenList>
        </li>
        <li>บริษัทไม่มีหน้าที่ตรวจสอบเนื้อหาของสมาชิกทั้งหมดล่วงหน้า</li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        ข้อ 11 ข้อจำกัดและการกระทำที่ต้องห้าม
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          สมาชิกต้องไม่กระทำการดังต่อไปนี้
          <PolicyHyphenList>
            <li>
              ให้ข้อมูลอันเป็นเท็จ
              หรือใช้บัญชีหรือข้อมูลระบุตัวบุคคลของผู้อื่นโดยไม่เหมาะสม;
            </li>
            <li>
              คัดลอก แก้ไข แจกจ่าย ขาย โอน ให้ยืม ทำวิศวกรรมย้อนกลับ ดีคอมไพล์
              หรือพยายามดึงซอร์สโค้ดของบริการโดยไม่ได้รับอนุญาต
              เว้นแต่กฎหมายที่ใช้บังคับจะอนุญาตไว้อย่างชัดแจ้ง;
            </li>
            <li>หมิ่นประมาท ข่มขู่ คุกคาม หรือทำร้ายผู้อื่นในลักษณะอื่น;</li>
            <li>
              โพสต์เนื้อหาที่ผิดกฎหมาย ลามก แสวงหาประโยชน์
              หรือถูกห้ามในลักษณะอื่น;
            </li>
            <li>
              ละเมิดลิขสิทธิ์ เครื่องหมายการค้า สิทธิความเป็นส่วนตัว
              หรือสิทธิอื่นของบริษัทหรือบุคคลที่สาม;
            </li>
            <li>
              เผยแพร่ข้อมูลอันเป็นเท็จหรือทำให้เข้าใจผิดเกี่ยวกับบริษัทหรือบุคคลอื่น;
            </li>
            <li>
              เผยแพร่เนื้อหาที่ขัดต่อกฎหมายที่ใช้บังคับหรือความสงบเรียบร้อยของประชาชน;
            </li>
            <li>
              นำมัลแวร์ ไวรัส โค้ดที่เป็นอันตราย
              หรือสิ่งอื่นที่ออกแบบมาเพื่อทำลายหรือรบกวนบริการเข้าสู่ระบบ;
            </li>
            <li>จงใจรบกวนหรือขัดขวางการดำเนินงานปกติของบริการ;</li>
            <li>
              แอบอ้างเป็นบุคคลอื่นหรือแสดงความสัมพันธ์กับบุคคลหรือองค์กรอื่นอย่างเป็นเท็จ;
            </li>
            <li>
              เก็บรวบรวม จัดเก็บ
              หรือเปิดเผยข้อมูลส่วนบุคคลของสมาชิกอื่นต่อสาธารณะโดยไม่มีอำนาจโดยชอบ;
            </li>
            <li>
              เผยแพร่ข้อมูลหลอกลวงเพื่อแสวงหาผลประโยชน์ทางการเงินหรือสร้างความเสียหาย;
            </li>
            <li>เข้าร่วมการพนันที่ผิดกฎหมายหรือกิจกรรมผิดกฎหมายอื่น;</li>
            <li>
              ชักชวนหรืออำนวยความสะดวกแก่บริการทางเพศที่ผิดกฎหมายหรือพฤติกรรมแสวงหาประโยชน์;
            </li>
            <li>
              ส่งเนื้อหาซ้ำ ๆ โดยมีเจตนาก่อให้เกิดความกลัว ความอับอาย การคุกคาม
              หรือความทุกข์ทางจิตใจอย่างร้ายแรง;
            </li>
            <li>ส่งหรือเผยแพร่ข้อมูลที่กฎหมายที่ใช้บังคับห้าม;</li>
            <li>
              แอบอ้างเป็นพนักงานบริษัท ผู้ดูแลบริการ หรือพันธมิตรทางธุรกิจ;
            </li>
            <li>
              ใช้ระบบรายงานในทางที่ผิดผ่านรายงานอันเป็นเท็จหรือมีเจตนาร้าย;
            </li>
            <li>
              สะกดรอย ใช้ถ้อยคำรุนแรง
              หรือรบกวนการใช้บริการของสมาชิกอื่นในรูปแบบอื่น หรือ
            </li>
            <li>
              ฝ่าฝืนกฎหมายที่ใช้บังคับ ข้อกำหนดฉบับนี้
              หรือนโยบายการดำเนินงานในลักษณะอื่น
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          การเข้าถึงบริการบางประเภทอาจถูกจำกัดตามอายุ คุณสมบัติ เขตอำนาจศาล
          หรือข้อกำหนดทางกฎหมายอื่น
        </li>
        <li>
          หากสมาชิกฝ่าฝืนข้อกำหนดในข้อนี้ บริษัทอาจตรวจสอบเรื่องดังกล่าว
          และอาจลบเนื้อหา จำกัดฟีเจอร์บางอย่างเป็นการชั่วคราวหรือถาวร ระงับบัญชี
          หรือยุติสัญญาการใช้บริการ
        </li>
        <li>
          บริษัทอาจใช้มาตรการที่เข้มงวดยิ่งขึ้นได้ทันทีในกรณีที่มีการกระทำผิดกฎหมายอย่างร้ายแรง
          สร้างความเสียหายอย่างมีนัยสำคัญต่อผู้อื่น เป็นภัยต่อความปลอดภัย
          ก่อให้เกิดความเสี่ยงด้านความมั่นคง หรือมีการฝ่าฝืนซ้ำ
        </li>
        <li>
          สมาชิกสามารถติดต่อฝ่ายบริการลูกค้าเพื่อขอให้ตรวจสอบมาตรการจำกัดการใช้งานที่บริษัทกำหนดได้
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>ข้อ 12 การยุติสัญญาการใช้บริการ</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          เมื่อสมาชิกทำการลบบัญชี
          สัญญาการใช้บริการระหว่างสมาชิกกับบริษัทจะสิ้นสุดลงด้วย
        </li>
        <li>
          สมาชิกสามารถขอลบบัญชีได้ทุกเมื่อผ่านฟังก์ชันที่มีอยู่ในบริการ
          หรือโดยติดต่อฝ่ายบริการลูกค้า
        </li>
        <li>
          เมื่อสัญญาการใช้บริการสิ้นสุดลง
          ข้อมูลสมาชิกและข้อมูลการใช้บริการจะถูกจัดการตามกฎหมายที่ใช้บังคับและ
          <strong>นโยบายความเป็นส่วนตัวของ pregnancy&amp;baby</strong>
        </li>
        <li>
          ข้อมูลส่วนบุคคลที่สามารถระบุตัวสมาชิกได้จะถูกลบตามนโยบายความเป็นส่วนตัว
          เว้นแต่กฎหมายที่ใช้บังคับจะกำหนดหรืออนุญาตให้เก็บรักษาไว้
        </li>
        <li>
          ข้อมูลการใช้บริการบางส่วนอาจถูกทำให้ไม่สามารถระบุตัวบุคคลได้อย่างถาวรและไม่สามารถย้อนกลับได้
          และเก็บรักษาไว้เพื่อวัตถุประสงค์ด้านการวิจัย สถิติ การวิเคราะห์
          และการปรับปรุงบริการ ตามที่ระบุไว้ในนโยบายความเป็นส่วนตัว
        </li>
        <li>
          เนื้อหาที่สมาชิกได้แชร์ต่อสาธารณะหรือกับสมาชิกอื่น เช่น
          โพสต์และความคิดเห็นในชุมชน อาจไม่ถูกลบโดยอัตโนมัติเมื่อบัญชีถูกลบ
          หากเนื้อหาดังกล่าวเป็นส่วนหนึ่งของการสนทนา การโต้ตอบ
          หรือพื้นที่ที่แชร์ร่วมกับสมาชิกอื่น
        </li>
        <li>
          สมาชิกควรลบเนื้อหาที่ต้องการนำออกก่อนลบบัญชี
          หากเนื้อหายังคงอยู่หลังลบบัญชี ข้อมูลบัญชีที่สามารถระบุตัวสมาชิก เช่น
          ชื่อเล่น อาจถูกลบหรือแยกออกจากเนื้อหาตามความเหมาะสม
        </li>
        <li>
          หากสมาชิกใช้บริการเข้าสู่ระบบของบุคคลที่สาม เช่น Google, Apple
          และลบหรือยกเลิกการเชื่อมโยงบัญชีดังกล่าว สมาชิกอาจไม่สามารถเข้าถึง
          pregnancy&amp;baby ผ่านวิธีการเข้าสู่ระบบนั้นได้อีก
        </li>
        <li>ข้อมูลที่ถูกลบเมื่อทำการลบบัญชี โดยทั่วไปไม่สามารถกู้คืนได้</li>
        <li>
          อดีตสมาชิกสามารถสมัครสร้างบัญชีใหม่ได้
          เว้นแต่จะมีข้อจำกัดในการสมัครใหม่เนื่องจากการฝ่าฝืนกฎหมายที่ใช้บังคับ
          ข้อกำหนดฉบับนี้ หรือนโยบายการดำเนินงานในอดีต
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>ข้อ 13 การคุ้มครองข้อมูลส่วนบุคคล</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          บริษัทประมวลผลข้อมูลส่วนบุคคลในขอบเขตที่จำเป็นต่อการให้บริการ
          และปฏิบัติตามกฎหมายด้านความเป็นส่วนตัวและการคุ้มครองข้อมูลส่วนบุคคลที่ใช้บังคับ
        </li>
        <li>
          ข้อมูลส่วนบุคคลจะถูกประมวลผลเฉพาะเพื่อวัตถุประสงค์และภายในขอบเขตที่ระบุไว้ในนโยบายความเป็นส่วนตัวของบริษัท
          เอกสารขอความยินยอมที่เกี่ยวข้อง และประกาศอื่นที่กฎหมายกำหนด
        </li>
        <li>
          เมื่อฟีเจอร์ใดจำเป็นต้องประมวลผลข้อมูลสุขภาพหรือข้อมูลส่วนบุคคลที่มีความอ่อนไหวอื่น
          บริษัทจะขอความยินยอมตามที่กฎหมายที่ใช้บังคับกำหนด
        </li>
        <li>
          บริษัทจะไม่เปิดเผยข้อมูลส่วนบุคคลแก่บุคคลที่สามที่เป็นอิสระ
          เว้นแต่ในกรณีต่อไปนี้
          <PolicyHyphenList>
            <li>ได้รับความยินยอมจากสมาชิก;</li>
            <li>ตามที่ระบุไว้ในนโยบายความเป็นส่วนตัว;</li>
            <li>เปิดเผยแก่ผู้ให้บริการที่ประมวลผลข้อมูลแทนบริษัท;</li>
            <li>กฎหมายกำหนดหรืออนุญาต หรือ</li>
            <li>กรณีอื่นที่กฎหมายอนุญาต</li>
          </PolicyHyphenList>
        </li>
        <li>
          รายละเอียดเกี่ยวกับการเก็บรวบรวม การใช้ การแบ่งปัน การเก็บรักษา
          การโอนข้อมูลไปต่างประเทศ และการคุ้มครองข้อมูลส่วนบุคคลของบริษัท
          สามารถดูได้จาก
          <strong>นโยบายความเป็นส่วนตัวของ pregnancy&amp;baby</strong>
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>บทที่ 4 บริการแบบมีค่าใช้จ่าย</PolicySectionTitle>
      <PolicyArticleTitle>
        ข้อ 14 ข้อมูลเกี่ยวกับบริการแบบมีค่าใช้จ่าย
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          หากบริษัทให้บริการแบบมีค่าใช้จ่าย
          สมาชิกสามารถใช้บริการดังกล่าวได้โดยชำระ
          <strong>ค่าบริการครั้งเดียว</strong>
          ตามเงื่อนไขที่แสดงสำหรับบริการแบบมีค่าใช้จ่ายนั้น
        </li>
        <li>
          ก่อนทำรายการซื้อเสร็จสมบูรณ์
          บริษัทหรือแอปสโตร์ที่เกี่ยวข้องจะจัดให้สมาชิกสามารถตรวจสอบข้อมูลสำคัญได้อย่างเหมาะสม
          เช่น
          <PolicyHyphenList>
            <li>ชื่อหรือคำอธิบายของบริการแบบมีค่าใช้จ่าย;</li>
            <li>ผู้ให้บริการแบบมีค่าใช้จ่าย;</li>
            <li>เนื้อหาและฟีเจอร์หลักของบริการแบบมีค่าใช้จ่าย;</li>
            <li>ราคาที่ใช้บังคับ; และ</li>
            <li>เงื่อนไขสำคัญอื่นของการซื้อที่กฎหมายที่ใช้บังคับกำหนด</li>
          </PolicyHyphenList>
        </li>
        <li>
          การใช้บริการแบบมีค่าใช้จ่ายอาจขึ้นอยู่กับอุปกรณ์ ระบบปฏิบัติการ ประเทศ
          แอปสโตร์ และข้อกำหนดทางเทคนิคอื่นของผู้ใช้
        </li>
        <li>
          เว้นแต่จะระบุไว้อย่างชัดเจนเป็นอย่างอื่น บริการแบบมีค่าใช้จ่ายเป็น
          <strong>
            การซื้อแบบครั้งเดียว ไม่มีการต่ออายุอัตโนมัติ
            และไม่มีการเรียกเก็บเงินซ้ำเป็นประจำ
          </strong>
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        ข้อ 15 การเกิดสัญญาสำหรับบริการแบบมีค่าใช้จ่าย
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          สมาชิกสามารถซื้อบริการแบบมีค่าใช้จ่ายผ่านขั้นตอนการซื้อที่บริษัทหรือแอปสโตร์ที่เกี่ยวข้องจัดให้
        </li>
        <li>
          ขั้นตอนการซื้ออาจรวมถึง
          <PolicyHyphenList>
            <li>การตรวจสอบและเลือกบริการแบบมีค่าใช้จ่าย;</li>
            <li>การตรวจสอบราคาและเงื่อนไขสำคัญ;</li>
            <li>การเลือกวิธีชำระเงินที่มีอยู่;</li>
            <li>การยืนยันการซื้อ; และ</li>
            <li>การชำระเงินให้เสร็จสมบูรณ์</li>
          </PolicyHyphenList>
        </li>
        <li>
          สัญญาสำหรับบริการแบบมีค่าใช้จ่ายจะเกิดขึ้นเมื่อการซื้อเสร็จสมบูรณ์และมีการแสดงหรือส่งการยืนยันการซื้อ
        </li>
        <li>
          บริษัทอาจปฏิเสธ ยกเลิก หรือระงับธุรกรรมในกรณีต่อไปนี้
          <PolicyHyphenList>
            <li>มีการใช้ข้อมูลอันเป็นเท็จหรือข้อมูลที่ไม่ได้รับอนุญาต;</li>
            <li>ไม่มีอำนาจโดยชอบในการใช้วิธีชำระเงิน;</li>
            <li>สมาชิกไม่มีความสามารถทางกฎหมายในการทำธุรกรรมนั้น;</li>
            <li>
              มีปัญหาทางเทคนิคหรือการดำเนินงานที่ทำให้ไม่สามารถทำธุรกรรมให้เสร็จสมบูรณ์;
            </li>
            <li>บัญชีของสมาชิกถูกระงับหรือจำกัดการใช้งาน หรือ</li>
            <li>
              ธุรกรรมขัดต่อกฎหมายที่ใช้บังคับ ข้อกำหนดฉบับนี้
              หรือนโยบายของแอปสโตร์ที่เกี่ยวข้อง
            </li>
          </PolicyHyphenList>
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        ข้อ 16 การชำระเงินสำหรับบริการแบบมีค่าใช้จ่าย
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          วิธีชำระเงินที่สมาชิกสามารถใช้ได้อาจแตกต่างกันตามประเทศ อุปกรณ์
          แพลตฟอร์ม และวิธีชำระเงินที่แอปสโตร์หรือผู้ให้บริการชำระเงินรองรับ
        </li>
        <li>
          หากซื้อบริการแบบมีค่าใช้จ่ายผ่านแอปพลิเคชันมือถือ
          การชำระเงินอาจดำเนินการในรูปแบบ
          <strong>
            การซื้อภายในแอปแบบครั้งเดียว (one-time in-app purchase)
          </strong>{" "}
          ผ่าน
          <PolicyHyphenList>
            <li>Apple App Store</li>
            <li>Google Play</li>
          </PolicyHyphenList>
        </li>
        <li>
          การชำระเงินผ่านแอปสโตร์อยู่ภายใต้เงื่อนไขการชำระเงิน
          กฎการเรียกเก็บเงิน ขั้นตอนการยกเลิก นโยบายการคืนเงิน
          และนโยบายอื่นที่เกี่ยวข้องของแอปสโตร์นั้น
        </li>
        <li>สมาชิกต้องใช้เฉพาะวิธีชำระเงินที่ตนมีสิทธิใช้โดยชอบด้วยกฎหมาย</li>
        <li>
          สมาชิกมีหน้าที่ตรวจสอบให้แน่ใจว่าข้อมูลที่ให้เกี่ยวกับการชำระเงินถูกต้องและใช้โดยชอบ
        </li>
        <li>
          ผู้ให้บริการชำระเงินหรือแอปสโตร์อาจกำหนดวงเงินธุรกรรม
          ข้อจำกัดด้านภูมิภาค ข้อกำหนดด้านอายุ หรือเงื่อนไขอื่น
        </li>
        <li>
          บริษัทไม่จัดเก็บข้อมูลบัตรชำระเงินฉบับเต็ม
          ในกรณีที่การชำระเงินดำเนินการทั้งหมดโดยแอปสโตร์หรือผู้ให้บริการชำระเงินอิสระ
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        ข้อ 17 การยกเลิกและการถอนการซื้อบริการแบบมีค่าใช้จ่าย
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          สิทธิของสมาชิกในการยกเลิกการซื้อ ใช้สิทธิถอน
          หรือขอคืนเงินสำหรับบริการแบบมีค่าใช้จ่าย จะพิจารณาตาม
          <PolicyHyphenList>
            <li>กฎหมายคุ้มครองผู้บริโภคที่ใช้บังคับ;</li>
            <li>ลักษณะของบริการแบบมีค่าใช้จ่าย;</li>
            <li>
              การที่บริการแบบมีค่าใช้จ่ายได้ถูกให้บริการหรือใช้งานแล้วหรือไม่;
            </li>
            <li>เงื่อนไขที่แจ้งไว้ในเวลาซื้อ; และ</li>
            <li>หากซื้อผ่านแอปสโตร์ นโยบายของแอปสโตร์นั้น</li>
          </PolicyHyphenList>
        </li>
        <li>
          สำหรับการซื้อผ่าน Apple App Store หรือ Google Play
          สมาชิกอาจต้องส่งคำขอยกเลิก ถอน
          หรือคืนเงินโดยตรงผ่านแอปสโตร์ที่เกี่ยวข้องตามนโยบายของแอปสโตร์นั้น
        </li>
        <li>
          เนื้อหาดิจิทัลหรือบริการบางประเภทอาจไม่สามารถถอนหรือคืนเงินได้หลังจากเริ่มให้บริการหรือเริ่มใช้งานแล้ว
          หากกฎหมายที่ใช้บังคับอนุญาต
          และมีการแจ้งหรือขอความยินยอมตามที่กฎหมายกำหนดแล้ว
        </li>
        <li>
          ไม่มีข้อกำหนดใดในเอกสารนี้ที่จำกัดสิทธิในการยกเลิก ถอน
          หรือขอคืนเงินที่กฎหมายที่ใช้บังคับรับรองไว้แก่สมาชิกโดยบังคับ
        </li>
        <li>
          สิทธิประโยชน์ คูปอง
          หรือสิทธิประโยชน์เพิ่มเติมอื่นที่ได้รับจากการซื้อซึ่งได้รับการคืนเงิน
          อาจถูกเพิกถอนหรือจำกัดการใช้ภายในขอบเขตที่กฎหมายที่ใช้บังคับอนุญาต
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        ข้อ 18 การจำกัดการใช้บริการแบบมีค่าใช้จ่าย
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          บริษัทจะจัดให้สมาชิกสามารถใช้บริการแบบมีค่าใช้จ่ายที่ซื้ออย่างถูกต้องตามเงื่อนไขที่แสดงไว้สำหรับบริการนั้น
        </li>
        <li>
          บริษัทอาจจำกัดหรือระงับการเข้าถึงบริการแบบมีค่าใช้จ่ายภายในขอบเขตที่กฎหมายที่ใช้บังคับอนุญาต
          หากสมาชิก
          <PolicyHyphenList>
            <li>ฝ่าฝืนข้อกำหนดฉบับนี้;</li>
            <li>กระทำการฉ้อโกงหรือผิดกฎหมาย;</li>
            <li>ใช้วิธีชำระเงินโดยไม่มีสิทธิ;</li>
            <li>ใช้ระบบคืนเงินหรือระบบชำระเงินในทางมิชอบ หรือ</li>
            <li>กระทำการอื่นที่มีเหตุอันสมควรตามกฎหมายในการจำกัดการใช้งาน</li>
          </PolicyHyphenList>
        </li>
        <li>
          ตามความเหมาะสม
          สมาชิกสามารถติดต่อฝ่ายบริการลูกค้าเพื่อขอให้ตรวจสอบมาตรการจำกัดดังกล่าว
        </li>
        <li>
          การจำกัดบริการแบบมีค่าใช้จ่ายไม่ได้เป็นการยุติบัญชี pregnancy&amp;baby
          ของสมาชิก เว้นแต่จะระบุไว้อย่างชัดเจนเป็นอย่างอื่น
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>ข้อ 19 การคืนเงิน</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          สิทธิในการขอคืนเงินและจำนวนเงินที่จะคืนขึ้นอยู่กับกฎหมายที่ใช้บังคับ
          ประเภทของบริการแบบมีค่าใช้จ่าย
          การที่บริการหรือเนื้อหาดิจิทัลถูกให้บริการหรือใช้งานแล้วหรือไม่
          และนโยบายที่แจ้งไว้ในเวลาซื้อ
        </li>
        <li>
          หากการชำระเงินดำเนินการผ่าน
          <strong>Apple App Store หรือ Google Play</strong>{" "}
          โดยทั่วไปนโยบายและขั้นตอนการคืนเงินของแอปสโตร์ดังกล่าวจะใช้บังคับ
          และบริษัทอาจไม่สามารถดำเนินการคืนเงินโดยตรงได้
        </li>
        <li>
          เนื้อหาดิจิทัลหรือบริการบางประเภทอาจไม่สามารถขอคืนเงินได้หลังจากเริ่มให้บริการหรือเริ่มใช้งานแล้ว
          หากกฎหมายที่ใช้บังคับอนุญาต
          และได้มีการแจ้งหรือขอความยินยอมตามที่กฎหมายกำหนดแล้ว
        </li>
        <li>
          หากบริการแบบมีค่าใช้จ่ายใดมีนโยบายคืนเงินแยกต่างหาก
          บริษัทจะแสดงนโยบายนั้นในระหว่างขั้นตอนการซื้อ
        </li>
        <li>
          ไม่มีข้อกำหนดใดในข้อนี้ที่ตัดสิทธิหรือจำกัดสิทธิในการคืนเงิน ยกเลิก
          ถอน
          หรือสิทธิอื่นของผู้บริโภคที่กฎหมายที่ใช้บังคับไม่อนุญาตให้ตัดหรือจำกัด
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>บทที่ 5 ข้อกำหนดอื่น</PolicySectionTitle>
      <PolicyArticleTitle>
        ข้อ 20 ข้อจำกัดความรับผิดและความรับผิด
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          ภายในขอบเขตสูงสุดที่กฎหมายที่ใช้บังคับอนุญาต
          บริษัทไม่ให้คำรับรองเกี่ยวกับเรื่องที่ไม่ได้ระบุไว้โดยชัดแจ้งในข้อกำหนดฉบับนี้
        </li>
        <li>
          บริษัทไม่รับประกันความครบถ้วน ความถูกต้อง ความน่าเชื่อถือ
          หรือความเหมาะสมสำหรับวัตถุประสงค์เฉพาะของข้อมูลจาก
          <PolicyHyphenList>
            <li>สมาชิก;</li>
            <li>ผู้ให้บริการเนื้อหาภายนอก;</li>
            <li>ฐานข้อมูลสาธารณะ;</li>
            <li>บริการภายนอก หรือ</li>
            <li>แหล่งข้อมูลอิสระอื่น</li>
          </PolicyHyphenList>
        </li>
        <li>
          บริการ รวมถึงการคาดการณ์รอบประจำเดือน
          การประมาณช่วงที่มีโอกาสตั้งครรภ์สูง
          การคำนวณที่เกี่ยวข้องกับการตั้งครรภ์
          การวิเคราะห์การเจริญเติบโตของทารกในครรภ์
          ข้อมูลการเจริญเติบโตและพัฒนาการของเด็ก และฟีเจอร์ด้านสุขภาพอื่น ๆ
          จัดให้มีขึ้น
          <strong>เพื่อให้ข้อมูลและสนับสนุนผู้ใช้</strong>
        </li>
        <li>
          บริการไม่ถือเป็นและไม่ได้มีวัตถุประสงค์เพื่อทดแทนการวินิจฉัย การตรวจ
          การรักษา หรือคำแนะนำทางการแพทย์จากผู้เชี่ยวชาญ
        </li>
        <li>
          หากความเสียหายเกิดจากการกระทำโดยเจตนาหรือความประมาทของบริษัท
          บริษัทจะรับผิดตามกฎหมายที่ใช้บังคับ
        </li>
        <li>
          ภายในขอบเขตที่กฎหมายที่ใช้บังคับอนุญาต
          บริษัทจะไม่รับผิดชอบต่อความเสียหายที่ไม่ได้เกิดจากการกระทำโดยเจตนาหรือความประมาทของบริษัท
          รวมถึงความเสียหายที่เกิดจาก
          <PolicyHyphenList>
            <li>
              เหตุสุดวิสัยหรือสถานการณ์ที่อยู่นอกการควบคุมโดยสมเหตุสมผลของบริษัท;
            </li>
            <li>การกระทำหรือการละเว้นของสมาชิกเอง;</li>
            <li>
              การเข้าถึงโดยไม่ได้รับอนุญาตหรือการโจมตีจากบุคคลที่สามซึ่งบริษัทไม่สามารถป้องกันได้อย่างสมเหตุสมผล;
            </li>
            <li>มัลแวร์หรือซอฟต์แวร์อันตรายที่บุคคลที่สามนำเข้ามา;</li>
            <li>
              ความล้มเหลวของเครือข่าย ระบบ
              หรือบริการของบุคคลที่สามซึ่งอยู่นอกการควบคุมโดยสมเหตุสมผลของบริษัท
              หรือ
            </li>
            <li>
              สถานการณ์อื่นที่ไม่ได้เกิดจากการกระทำโดยเจตนาหรือความประมาทของบริษัท
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          ภายในขอบเขตที่กฎหมายที่ใช้บังคับอนุญาต
          บริษัทไม่รับผิดชอบต่อข้อพิพาทที่เกิดขึ้นระหว่างสมาชิกด้วยกันเอง
          หรือระหว่างสมาชิกกับบุคคลที่สามที่เป็นอิสระ
          เว้นแต่บริษัทจะมีความรับผิดทางกฎหมายในเรื่องดังกล่าว
        </li>
        <li>
          ไม่มีข้อกำหนดใดในเอกสารนี้ที่ตัดหรือจำกัดความรับผิดที่ไม่สามารถตัดหรือจำกัดได้ตามกฎหมายคุ้มครองผู้บริโภคหรือบทบัญญัติบังคับอื่น
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>ข้อ 21 การแจ้งและการติดต่อ</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          สมาชิกสามารถติดต่อบริษัทผ่านฝ่ายบริการลูกค้าได้ทุกเมื่อเกี่ยวกับบริการ
        </li>
        <li>
          ประกาศทั่วไปสำหรับสมาชิกอาจแจ้งผ่านประกาศภายในบริการเป็นเวลาไม่น้อยกว่าเจ็ด
          (7) วัน หรือด้วยวิธีการที่เหมาะสมอื่น
        </li>
        <li>
          เรื่องที่มีผลกระทบอย่างมีนัยสำคัญต่อสิทธิของสมาชิกหรือการใช้บริการ
          อาจแจ้งเป็นรายบุคคลผ่าน
          <PolicyHyphenList>
            <li>อีเมล;</li>
            <li>การแจ้งเตือนแบบพุช;</li>
            <li>ข้อความภายในแอป หรือ</li>
            <li>วิธีการทางอิเล็กทรอนิกส์ที่เหมาะสมอื่น</li>
          </PolicyHyphenList>
        </li>
        <li>
          บริษัทไม่มีหน้าที่ต้องใช้ช่องทางการติดต่อที่สมาชิกไม่ได้ให้ข้อมูลที่จำเป็นสำหรับการรับการแจ้งผ่านช่องทางนั้น
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        ข้อ 22 กฎหมายที่ใช้บังคับและการระงับข้อพิพาท
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          ข้อกำหนดฉบับนี้และความสัมพันธ์ระหว่างบริษัทกับสมาชิก
          โดยทั่วไปอยู่ภายใต้กฎหมายของ
          <strong>สาธารณรัฐเกาหลี</strong>{" "}
          โดยไม่กระทบต่อบทบัญญัติบังคับด้านการคุ้มครองผู้บริโภคหรือสิทธิบังคับอื่นที่ใช้บังคับตามกฎหมายของประเทศหรือภูมิภาคที่สมาชิกพำนักอยู่
        </li>
        <li>
          หากเกิดข้อพิพาทเกี่ยวกับบริการ
          บริษัทและสมาชิกจะพยายามอย่างสมเหตุสมผลในการแก้ไขปัญหาด้วยการเจรจาโดยสุจริตก่อน
        </li>
        <li>
          หากไม่สามารถระงับข้อพิพาทโดยการเจรจาได้
          อาจนำข้อพิพาทเข้าสู่ศาลที่มีเขตอำนาจตามกฎหมายที่ใช้บังคับ
        </li>
        <li>
          ไม่มีข้อกำหนดใดในเอกสารนี้ที่ตัดสิทธิของสมาชิกในการยื่นข้อเรียกร้องต่อศาลหรือหน่วยงานที่มีอำนาจ
          หากสิทธิดังกล่าวได้รับการรับรองโดยบทบัญญัติบังคับในประเทศหรือภูมิภาคที่สมาชิกพำนักอยู่
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>ข้อ 23 ข้อกำหนดทั่วไป</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          เรื่องที่ไม่ได้ระบุไว้อย่างชัดเจนในข้อกำหนดฉบับนี้
          ให้เป็นไปตามกฎหมายที่ใช้บังคับ และในขอบเขตที่กฎหมายอนุญาต
          ให้เป็นไปตามแนวปฏิบัติที่ยอมรับกันทั่วไป
        </li>
        <li>
          หากข้อกำหนดข้อใดถูกวินิจฉัยว่าเป็นโมฆะ ผิดกฎหมาย
          หรือไม่สามารถบังคับใช้ได้
          ข้อกำหนดอื่นยังคงมีผลต่อไปภายในขอบเขตสูงสุดที่กฎหมายอนุญาต
        </li>
        <li>
          การที่บริษัทไม่บังคับใช้ข้อกำหนดข้อใด
          ไม่ถือเป็นการสละสิทธิในข้อกำหนดนั้นหรือสิทธิอื่น
        </li>
        <li>
          หัวข้อที่ใช้ในข้อกำหนดฉบับนี้มีไว้เพื่อความสะดวกเท่านั้น
          และไม่มีผลต่อการตีความข้อกำหนด
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>บทเฉพาะกาล</PolicyArticleTitle>
      <PolicyText>
        ข้อกำหนดฉบับนี้มีผลตั้งแต่ <strong>[21 กันยายน 2026]</strong>
      </PolicyText>
      <PolicyText>
        สำหรับสมาชิกใหม่ที่สมัครหลังจากประกาศข้อกำหนดฉบับนี้
        แต่ก่อนวันที่มีผลบังคับใช้ที่ระบุไว้
        บริษัทอาจใช้ข้อกำหนดฉบับนี้ตั้งแต่วันที่สมัครสมาชิก
        ภายในขอบเขตที่กฎหมายที่ใช้บังคับอนุญาต
      </PolicyText>
    </PolicyContainer>
  );
};

export default ServiceTh;
